class ApiService {
    constructor() {
        this.baseURL = process.env.REACT_APP_API_BASE_URL || 'https://d0a04189.makameter.pages.dev';
    }

    async request(endpoint, options = {}) {
        const url = `${this.baseURL}${endpoint}`;
        
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Origin': window.location.origin,
                ...options.headers,
            },
            mode: 'cors',
            credentials: 'omit',
            ...options,
        };

        try {
            const response = await fetch(url, config);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return await response.json();
            } else {
                const text = await response.text();
                console.warn('Non-JSON response:', text);
                return { success: false, error: 'Invalid response format' };
            }
        } catch (error) {
            console.error('API request failed:', error);
            throw error;
        }
    }

    async startRide(startLocation) {
        return await this.request('/api/rides/start', {
            method: 'POST',
            body: JSON.stringify({
                startLocation: {
                    lat: startLocation.lat,
                    lng: startLocation.lng,
                    timestamp: startLocation.timestamp
                }
            })
        });
    }

    async updateRide(rideId, currentLocation, distance) {
        return await this.request(`/api/rides/${rideId}`, {
            method: 'PUT',
            body: JSON.stringify({
                currentLocation: {
                    lat: currentLocation.lat,
                    lng: currentLocation.lng,
                    timestamp: currentLocation.timestamp
                },
                distance
            })
        });
    }

    async endRide(rideId, endLocation, finalDistance) {
        return await this.request(`/api/rides/${rideId}/end`, {
            method: 'PUT',
            body: JSON.stringify({
                endLocation: {
                    lat: endLocation.lat,
                    lng: endLocation.lng,
                    timestamp: endLocation.timestamp
                },
                finalDistance
            })
        });
    }

    async getRideHistory() {
        return await this.request('/api/rides/history', {
            method: 'GET'
        });
    }

    async getRide(rideId) {
        return await this.request(`/api/rides/${rideId}`, {
            method: 'GET'
        });
    }
}

export default new ApiService();